<template>
  <div>
    <GrowerReport
      v-if="reportType === 'grower' && !reportError"
      :reportData="reportData"
    />
    <FieldPerformanceReport
      v-if="reportType === 'field-performance' && !reportError"
      :reportData="reportData"
      :voxelGeom="voxelGeom"
    />
    <div class="my-8 mx-8" v-if="reportError">
      Error fetching report data.
    </div>
  </div>
</template>

<script>
import { fetchReportData, fetchGrowerReportData } from "@/api/ReportsAPI"
import FieldPerformanceReport from "@/components/reports/FieldPerformanceReport"
import GrowerReport from "@/components/reports/GrowerReport"

export default {
  name: "PDFGeneratorView",
  components: { FieldPerformanceReport, GrowerReport },
  data() {
    return {
      boundaryData: null,
      reportType: null,
      reportData: null,
      voxelGeom: null,
      reportError: false,
    }
  },

  async mounted() {
    const { reportHash } = this.$route.params

    console.log('route:', this.$route)
    // this ugliness is because this component is not actually loaded from the router
    // (where we could insert whatever props we needed) - it is sitting in App.vue
    if (this.$route.name.includes("arva-grower-pdf-generator")) {
      await fetchGrowerReportData(reportHash).then(resp => {
        const { report_type, report_data, voxel_geom } = resp.data
        console.log("report data: ", report_data, voxel_geom)
        this.reportType = report_type
        this.reportData = report_data
      }).catch(error => {
        console.error(error)
        this.reportError = true
      })
    } else {
      await fetchReportData(reportHash).then(resp => {
        const { report_type, report_data, voxel_geom } = resp.data
        this.reportType = report_type
        this.reportData = report_data
        this.voxelGeom = voxel_geom
      }).catch(error => {
        console.error(error)
        this.reportError = true
      })
    }
  },

  beforeCreate() {
    document.body.className = "pdf-body"
  },
}
</script>
<style scoped>
body {
  background-color: white !important;
}
</style>
